// @ts-nocheck

import dash_api from '../../support/dash_api';
import { ReduxAsyncAction } from '../../support/utils';
import NotificationActions from '../NotificationActions';

const ERROR = 'error';
const ERROR_MESSAGE = {
  REQUEST: 'An error occurred. Please refresh the page',
  DUPLICATES: 'SEO Domains list is invalid. Duplicate domains are not allowed.',
};

const UpdateOrganicSearchDomains = new ReduxAsyncAction('UPDATE_ORGANIC_SEARCH_DOMAINS');
UpdateOrganicSearchDomains.registerRequest(async (organic_search_domains: string[]) => {
  const duplicatesFound = new Set(organic_search_domains).size !== organic_search_domains.length;
  if (duplicatesFound) {
    return NotificationActions.showNotification(ERROR_MESSAGE.DUPLICATES, ERROR);
  }

  try {
    await dash_api
      .post('/v1/seo/configuration', { organic_search_domains: organic_search_domains.toString() })
      .then(({ data }) => {
        return data;
      })
      .catch(() => {
        NotificationActions.showNotification(ERROR_MESSAGE.REQUEST, ERROR);
      });

    return organic_search_domains;
  } catch (e) {
    NotificationActions.showNotification(ERROR_MESSAGE.REQUEST, ERROR);
    throw e;
  }
});
export const UPDATE_ORGANIC_SEARCH_DOMAINS: any = UpdateOrganicSearchDomains.constants;
export const updateOrganicSearchDomains = UpdateOrganicSearchDomains.request;
